/*
 * File: d:\projects\AutoFiFront\src\Utils\GetEnergyToDisplay.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 11:54:08 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Gasoline from 'Content/SVG/EnergySVG/Gasoline';
import Diesel from 'Content/SVG/EnergySVG/Diesel';
import Ethanol from 'Content/SVG/EnergySVG/Ethanol';
import Electric from 'Content/SVG/EnergySVG/Electric';
import Hybrid from 'Content/SVG/EnergySVG/Hybrid';
import { SVGProps } from 'Content/SVG/SVGProps';

const getEnergyToDisplay = (energy: string, props:SVGProps) => {
    let myRet;
    switch (energy) {
        case "electric":
            myRet = <Electric fill={props.fill} stroke={props.fill2} strokeWidth={"20px"} width={props.width}/>;
            break;
        case "diesel":
            myRet = <Diesel fill={props.fill} stroke={props.fill2} strokeWidth={"20px"} width={props.width}/>;
            break;
        case "gasoline":
            myRet = <Gasoline fill={props.fill} stroke={props.fill2} strokeWidth={"20px"} width={props.width}/>;
            break;
        case "hybrid":
            myRet = <Hybrid fill={props.fill} stroke={props.fill2} strokeWidth={"20px"} width={props.width}/>;
            break;
        case "biofuel":
            myRet = <Ethanol fill={props.fill} stroke={props.fill2} strokeWidth={"20px"} width={props.width}/>;
            break;
        default:
            myRet = null;
            break;
    }
    return myRet;
};

export default getEnergyToDisplay;
